import '../../App.css'
import {globals} from '../Globals/Globals'

const Hyperlien = (pOHyperlink) => {
  return <a className='footer-links'
            target="_blank"
            href={`${pOHyperlink.href}`}>{pOHyperlink.text}</a>
}

const FooterPage = () => {
    //rendering
    return(
         <div id="footer-container" className="col-12"> 
           <div id="footer-suggest">
            <strong>Sites Utiles</strong>
            <ul>
              <li>{Hyperlien({href:"https://adventiste.org",text:"Adventiste.org"})}</li>
              <li>{Hyperlien({href:"https://adventisteffs.org/",text:"Fédération France Sud"})}</li>
              <li>{Hyperlien({href:"https://www.youtube.com/@jeunesse.Adventiste",text:"Youtube Jeunesse Adventiste"})}</li>
              <li>{Hyperlien({href:"https://adventlife.fr/adventradio/V5/index.html",text:"Radio ADVENTLIFE"})}</li>
              <li>{Hyperlien({href:"https://hopetv.org/",text:"HopeChannel"})}</li>
            </ul>
            </div>
            <div id="footer-bottom">
             <div id="social-networks">
              {true &&
               <div onClick={()=>{window.open(globals.links.facebook)}} id='facebook'/>
               }
               {false &&
               <div className="pmc-powered-container" style={{display: 'flex', justifyContent: 'center', marginRight: 'auto', fontSize: 'smaller'}}>
                  
                  <a id="pmc-powered" href="https://neuronal.bible" target="_blank" rel="noopener noreferrer" aria-label="PMC powered">
                    <span className="pmc-text" style={{color: 'white',marginRight: '4px'}}>{globals.menu.version}</span>
                    <svg className="pmc-logo" viewBox="0 0 199 145" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{width: '26px', height: '18px', fill: 'green'}}>
                      <g fill="#00FFA3">
                        <polygon points="0,72.5 51,24 66,41 40,72.5 66,104 51,121"/>
                        <rect x="90" y="0" width="19" height="145" transform="rotate(20 99.5 72.5)"/>
                        <polygon points="199,72.5 148,24 133,41 159,72.5 133,104 148,121"/>
                      </g>
                    </svg>
                    <span className="pmc-text" style={{color: 'white', marginLeft: '-4px'}}>pmc powered</span>
                  </a>
              </div>}
             </div>

             <div className="footer-copyrights">
                <div>&copy;2022-2026 Eglise Adventiste de Thonon-les-bains</div>
                 {/*
                <div>Propulsé par <a href="http://www.bibleforce.com" target="_blank">http://www.bibleforce.com</a></div>
                 */}
             </div>
           </div>
         </div>
     )
}

export default FooterPage;


